module.exports = "/images/img_tshirt_1.png?6144427c870db119270021672b86d52c";